<template>
  <div style="width: 100%;height: 100%">
    <router-link to="/"></router-link>
    <router-view></router-view>
  </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue